'use client';

import { ERoute } from '@/configs/routes';
import { getRestrictedRoutes } from '@/utils/common';
import { usePathname, useRouter } from 'next/navigation';
import { ReactNode, useEffect, useMemo } from 'react';
import { usePrivate } from '@/components/private';
import { SELECTED_ORG_ID } from '@/configs/storageKeys';

type TOwnProps = {
  children?: ReactNode;
};

export const ProtectedLayer = (props: TOwnProps) => {
  const { children } = props;
  const { push } = useRouter();
  const pathName = usePathname();

  const { userOrganisations } = usePrivate();

  const selectedOrganisationId = parseInt(
    window.localStorage.getItem(SELECTED_ORG_ID) ?? '-1',
  );

  // Get current path
  const currentPath = pathName;
  const pathArr = currentPath.split('/');

  // Checking if sub route is availle to split to get the main path
  const hasSubRoute = pathArr.length > 2;

  const subRoute = hasSubRoute && pathArr.pop();

  const currentOrg = userOrganisations?.find(
    (o) => o.organisationId === selectedOrganisationId,
  );

  const isNotAllowed: boolean = useMemo(() => {
    if (currentPath === '/') {
      return false;
    }

    const restrictedRoutes =
      (currentOrg && getRestrictedRoutes(currentOrg?.roleId!)) || [];

    if (hasSubRoute) {
      return restrictedRoutes.some((r) => r.href === subRoute);
    }

    return restrictedRoutes.some((r) => {
      return r.href === currentPath;
    });
  }, [currentOrg, currentPath, subRoute, hasSubRoute]);

  useEffect(() => {
    if (isNotAllowed) {
      push('/' + ERoute.RESTRICTED);
    }
    //eslint-disable-next-line
  }, [isNotAllowed]);

  if (!selectedOrganisationId) {
    return children;
  }

  return children;
};
